const hostname = window.location.hostname;
const isHttps = window.location.protocol === 'https:';

const config = {
    host: hostname,

    port: isHttps ? 443 : 3011,

    apiUrl: isHttps
        ? window.location.origin
        : `http://${hostname}:3011`,

    relayHost: hostname,
    relayPort: isHttps ? 443 : 3002,

    relayUrl: isHttps
        ? `wss://${window.location.host}`
        : `ws://${hostname}:3002`,

    useSsl: isHttps,
};

if (config.useSsl) {
    config.relayUrl = `wss://${config.relayHost}`;
} else {
    config.relayUrl = `ws://${config.relayHost}:${config.relayPort}`;
}

export default config;
